import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// Connects to data-controller="file"
// TODO: UploadButtonControllerに統合
export default class extends Controller {
  static targets = ["input", "nameArea", "name"];
  static values = { fileName: String };

  connect() {
    this.changeFile();
  }

  clickUpload() {
    this.inputTarget.click();
  }

  changeFile() {
    this.fileNameValue = this.inputTarget?.files[0]?.name;
  }

  removeFile() {
    this.inputTarget.value = "";
    this.fileNameValue = "";
  }

  fileNameValueChanged() {
    const newText = this.fileNameValue;
    const area = this.nameAreaTarget;
    if (area) {
      if (newText) {
        $(area).show();
      } else {
        $(area).hide();
      }
    }
    this.nameTarget.textContent = newText || "";
  }
}
